import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { columns } from './services-grid-columns';
import { servicesApiKeyStore } from '../../../../api/masters/services-api-key-store';

import { useEffect, useState } from 'react';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { Service } from '../../../../models/masters/service';
import { serviceBundleApiKeyStore } from '../../../../api/service-bundle-api-key-store';
import { Button, IconButton, Tooltip, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { ServiceBundle } from '../../../../models/service-bundle';
import { ServicesDetails } from './service-details';
import { ServiceBundleDialog } from '../service-bundle/service-bundle.dialog';
import { servicesEditableColumns } from '../../../services/grid-editable-columns';
import { Unit } from '../../../../models/unit';
import { UserPermissionName } from '../../../../models/user-permission-name';

interface CellProps {
  bundleService: any;
}

interface CustomGridCellProps {
  field: string;
}
interface OfficeTabProps {
  unitID: number;
  unit?: Unit;
}

const DEFAULT_GROUP = [
  {
    field: 'serviceGroupName',
  },
];

export const ServicesTab = ({ unitID, unit }: OfficeTabProps) => {
  const [openServiceBundle, setOpenServiceBundle] = useState(false);
  const [openServiceList, setOpenServiceList] = useState(false);
  const [value, setValue] = useState('create');
  const [splitID, setSplitID] = useState(0);
  const [editItem, setEditItem] = useState<ServiceBundle>();

  return (
    // <div className="borderTop">
    //   <Button
    //     className="innerTab-button"
    //     size="small"
    //     variant="contained"
    //     disableElevation={true}
    //     onClick={handleOpenBundleDialog}
    //   >
    //     Add SERVICE BUNDLE
    //   </Button>
    //   <SiTrackGrid
    //     columns={columns}
    //     dataItemKey="typeID"
    //     customCell={(field) =>
    //       CustomGridCell({
    //         field,
    //       })
    //     }
    //     showWithoutSorting={true}
    //     dataItems={data?.data}
    //     isBusy={isLoading}
    //     footerCell={FooterCell}
    //   />
    //   {openServiceBundle && (
    //     <ServiceBundleDialog
    //       value={value}
    //       setValue={setValue}
    //       unitID={unitID}
    //       open={openServiceBundle}
    //       onClose={handleCloseBundleDialog}
    //       editItem={editItem}
    //       setEditItem={setEditItem}
    //       refetch={refetch}
    //     />
    //   )}
    //   {openServiceList && (
    //     <ServicesDetails splitID={splitID} open={openServiceList} onClose={() => setOpenServiceList(false)} />
    //   )}
    // </div>
    <SiTrackGrid
      fileTitle='unit_service'
      columns={servicesEditableColumns}
      // defaultGroup={DEFAULT_GROUP}
      dataItemKey="serviceID"
      dataItems={unit?.unitServices || []}
      actionPermissions={{
        export: UserPermissionName.DOWNLOAD_GRID,
      }}
    // queryConfig={servicesApiKeyStore.getServiceMappingList(0, 0, 0, unitID, 0)}
    />
  );
};
